import { useEffect } from 'react';
import { useViewModel } from '@/shared/viewmodels/useViewModel';
import IntegrationsPageLayout from '@/features/integrations/IntegrationsPageLayout';
import { IdentityProvidersPageViewModel } from '@/features/integrations/IdentityProvidersPageViewModel';

export default function IdentityProvidersPage(): React.ReactElement {
    const vm = useViewModel(IdentityProvidersPageViewModel);

    useEffect(() => {
        void vm.load();
    }, [vm]);

    return (
        <IntegrationsPageLayout
            vm={vm}
            title="Identity Providers"
            subtitle="Connect this tenant to external directory services for user and group sync."
            addLabel="Add identity provider"
            emptyTitle="No identity providers connected"
            emptyDescription="Connect a directory like Google Workspace or Entra ID to sync users and groups."
        />
    );
}
